// Legal page URLs - Update these with your actual URLs
export const LEGAL_URLS = {
  TERMS_OF_SERVICE: process.env.REACT_APP_TERMS_OF_SERVICE_URL || 'https://example.com/terms-of-service',
  PRIVACY_POLICY: process.env.REACT_APP_PRIVACY_POLICY_URL || 'https://example.com/privacy-policy'
};
